import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Map as MapIcon, X } from "lucide-react";
import { getConsent } from "./CookieConsent";

const KEY = "lm_demo_prompt_dismissed";

export const DemoPrompt = () => {
  const { pathname } = useLocation();
  const [dismissed, setDismissed] = useState(() => typeof window !== "undefined" && sessionStorage.getItem(KEY) === "1");
  const [shown, setShown] = useState(false);

  // Stay hidden until the cookie notice has been answered so the two never stack.
  useEffect(() => {
    setShown(false);
    let t;
    const reveal = () => { t = setTimeout(() => setShown(true), 900); };
    if (getConsent()) reveal();
    window.addEventListener("lm:consent", reveal);
    return () => { clearTimeout(t); window.removeEventListener("lm:consent", reveal); };
  }, [pathname]);

  if (pathname === "/" || pathname.startsWith("/admin") || dismissed) return null;

  const dismiss = () => {
    sessionStorage.setItem(KEY, "1");
    setDismissed(true);
  };

  return (
    <div
      data-testid="demo-prompt"
      className={`fixed z-40 bottom-5 left-1/2 -translate-x-1/2 sm:left-6 sm:translate-x-0 transition-all duration-500 ${
        shown ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <div className="flex items-center gap-1 rounded-full bg-[#0A1628] text-white pl-1.5 pr-1.5 py-1.5 shadow-[0_12px_40px_-8px_rgba(14,165,233,0.55)] ring-1 ring-cyan-400/50">
        <Link
          to="/#sample-map"
          data-testid="demo-prompt-link"
          className="group inline-flex items-center gap-2.5 rounded-full pl-1 pr-3 py-1 hover:bg-white/5 transition-colors"
        >
          <span className="relative flex items-center justify-center w-8 h-8 rounded-full bg-gradient-to-br from-cyan-400 to-teal-400 text-slate-950">
            <span className="absolute inset-0 rounded-full bg-cyan-300/60 animate-ping" />
            <MapIcon className="relative w-4 h-4" />
          </span>
          <span className="text-sm font-semibold whitespace-nowrap">
            Try the live map <span className="hidden sm:inline text-cyan-200 font-normal">· explore a real survey</span>
          </span>
        </Link>
        <button
          type="button"
          data-testid="demo-prompt-dismiss"
          onClick={dismiss}
          aria-label="Dismiss"
          className="w-8 h-8 rounded-full text-slate-400 hover:text-white hover:bg-white/10 flex items-center justify-center transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};
